import HttpModule from "./_http_module";

export default class UtilitiesApi extends HttpModule {
	getDashboard({ onSuccess, onFail }) {
		super._get("dashboard", { onSuccess, onFail });
	}
}
